import { render, staticRenderFns } from "./SavedItems.vue?vue&type=template&id=3f054f01&"
import script from "./SavedItems.vue?vue&type=script&lang=js&"
export * from "./SavedItems.vue?vue&type=script&lang=js&"
import style0 from "./SavedItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SavedItems.vue"
export default component.exports